export enum JobStatus {
    Created = 0,
    Scheduled = 1,
    Stopped = 2,
    Finished = 3,
    Deleted = 4,
    Submitted = 5,
    Validated = 6,
    QuotaInsufficient = 7
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/jobStatus.ts